import React from 'react'
import { Formik, Form } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import EditModeButton from '../1elements/Buttons/IconButtons/EditModeButton'
import SaveCancelButtonFooter from '../1elements/Buttons/SaveCancelButtonFooter'
import { Text } from '../1elements'

const useStyles = makeStyles((theme) => ({
  outerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',          
    width: '100%',
    position: 'relative',
  },

  scrollArea: {
    flex: 1,                 
    overflowY: 'auto',       
    padding: theme.spacing(2),
  },

  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },

  tabTitle: {
    marginRight: theme.spacing(2),
  },

  saveCancelContainer: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
  },
}))

export default function TabTemplate({
  tabTitle,
  editMode,
  setEditMode,
  handleSave,
  handleCancel,
  children,
  className,
}) {
  const classes = useStyles()

  return (
    <div className={`${classes.outerWrapper} ${className}`}>
      <Formik
        initialValues={{}}
        onSubmit={() => {}}
      >
        {() => (
          <Form style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className={classes.scrollArea}>
              <div className={classes.topRow}>
                {tabTitle && (
                  <Text type="h1" className={classes.tabTitle}>
                    {tabTitle}
                  </Text>
                )}
                <EditModeButton
                  onEditMode={editMode}
                  setOnEditMode={() => setEditMode(!editMode)}
                />
              </div>

              {typeof children === 'function' ? children() : children}

              {editMode && (
                <div className={classes.saveCancelContainer}>
                  <SaveCancelButtonFooter
                    saveHandler={handleSave}
                    cancelHandler={handleCancel}
                  />
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
